var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Upload',{staticClass:"upld-wrpr",attrs:{"drag":"","before-upload":_vm.handleBefore,"action":_vm.actionURL,"on-error":_vm.handleError,"on-success":_vm.handleSuccess,"on-exceed":_vm.handleExceed,"disabled":false,"limit":100,"multiple":false,"show-file-list":false,"accept":_vm.dataAccept}},[_vm._t("trigger"),_vm._t("tip")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }